export enum StyleListFormValue {
  DESCRIPTION = 'Description',
}
